<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات خدمت"
        >
          <b-form
            ref="dutyform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="8">
                    <b-form-group
                      label="زیرنویس"
                      label-for="Subtitle"
                    >
                      <b-form-input
                        v-model="Form.Subtitle"
                        autocomplete="off"
                        name="Subtitle"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="قیمت"
                      label-for="Price"
                    >
                      <b-input-group append="تومان">
                        <cleave
                          v-model="Form.Price"
                          class="form-control"
                          :raw="false"
                          :options="options"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="پیوند یکتا"
                      label-for="Slug"
                    >
                      <b-form-input
                        id="Sort"
                        v-model="Form.Slug"
                        name="Slug"
                        autocomplete="off"
                        dir="ltr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1 mb-2">
                      <b-form-checkbox
                        v-model="Form.IsActive"
                        value="true"
                        class="custom-control-success"
                        name="IsActive"
                      >
                        برای کاربر نمایش داده شود؟
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                      label="تگ ها"
                      label-for="Tag"
                    >
                      <b-form-tags
                        v-model="Form.Tag"
                        name="Tag"
                        placeholder=""
                        add-button-text="افزودن"
                        add-button-variant="outline-primary"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        گالری
                      </div>
                    </div>
                  </b-col>

                  <div
                    v-for="(item, index) in Form.DutyGallery"
                    :key="item.Id"
                    class="px-1 mb-1"
                  >
                    <b-avatar
                      ref="previewEl"
                      :src="item.Url"
                      size="120px"
                      rounded
                      class="foodrecipes-image mt-1"
                    />
                    <b-form-group style="width: 120px;">
                      <b-form-input
                        v-model="item.Title"
                        autocomplete="off"
                        class="mt-1"
                        @click="showModal(item)"
                      />
                    </b-form-group>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      style=""
                      class="btn-icon video-remove"
                      @click="removeGallery(item)"
                    >
                      <feather-icon
                        icon="XIcon"
                        size="14"
                      />
                    </b-button>
                  </div>

                  <input
                    ref="refGalley"
                    type="file"
                    class="d-none"
                    accept="image/*"
                    @change="galleryRenderer($event)"
                  >

                  <div class="px-1 mb-1 mt-1">
                    <div
                      class="activity-upload-video"
                      @click="$refs.refGalley.click()"
                    >
                      <div class="activity-upload-video-icon">
                        <feather-icon
                          size="24"
                          icon="UploadIcon"
                        />
                      </div>
                    </div>
                  </div>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showImageModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="اضافه کردن  alt به تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveImageAlt"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Alt"
            label-for="Alt"
          >
            <b-form-input
              id="Alt"
              v-model="imageAlt"
              name="Title"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if="isShowModal"
      v-model="isShowModal"
      ok-title="ذخیره"
      centered
      ok-only
      title="عنوان تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveModal"
    >
      <b-row class="mt-1">
        <b-col md="12">
          <b-form-group>
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
              autofocus
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </b-overlay>
</template>

<script>

import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'ProjectDetails',
  components: { ZSeo, ZQuillEditor },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Subtitle: null,
        Tag: [],
        Price: null,
        Image: null,
        Description: null,
        Visibility: true,
        DutyGallery: [],
        DutyQuestion: [],
        Slug: null,
      },
      GalleryFile: [],
      loading: false,
      galleryId: 0,
      ProjectSpecificationRemoveId: null,
      isShowModal: false,
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.duty.add
      if (this.$route.params.id) {
        url = this.$api.duty.update
      }

      const formData = new FormData(this.$refs.dutyform)
      formData.append('Id', this.Form.Id)
      formData.append('Visibility', this.Form.Visibility)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.Price) {
        formData.append('Price', this.Form.Price.replaceAll(',', ''))
      }

      this.Form.DutyGallery.forEach((item, index) => {
        formData.append(`DutyGallery[${index}].Id`, item.Id)
        if (item.Title) {
          formData.append(`DutyGallery[${index}].Title`, item.Title)
        }

        formData.append(`DutyGallery[${index}].Sort`, index)
        if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
          formData.append(`DutyGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
        }
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    galleryRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.galleryId++

        this.Form.DutyGallery.push({ Url: fileReader.result, Id: this.galleryId })
        this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId })
      }
    },
    removeGallery(item) {
      this.Form.DutyGallery = this.Form.DutyGallery.filter(x => x.Id !== item.Id)
    },
    addProjectSpecification() {
      this.Form.ProjectSpecification.push({
        Title: '', Description: '',
      })
    },
    removeProjectSpecification(index) {
      this.ProjectSpecificationRemoveId = index
    },
    confirmProjectSpecification() {
      this.Form.ProjectSpecification.splice(this.ProjectSpecificationRemoveId, 1)
      this.ProjectSpecificationRemoveId = null
    },
    cancelProjectSpecification() {
      this.ProjectSpecificationRemoveId = null
    },
    editorIsChange() {
      // document.querySelectorAll('#Description img').forEach(img => {
      //   img.onclick = e => {
      //     console.log('ggg')
      //     this.elementTemp = e
      //     this.AltTemp = e.target.getAttribute('alt')
      //     this.showModalImageAttr = true
      //   }
      // })
      // document.querySelectorAll('#Description a').forEach(a => {
      //   cons
      //   a.onclick = e => {
      //     this.elementTemp = e
      //     this.showModalLinkAttr = true
      //   }
      // })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.duty.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    showModal(row) {
      this.isShowModal = true
      this.row = row
    },
    saveModal() {
      this.isShowModal = false
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
